import {HospRealizeOrderList} from "./HospRealizeOrderList";
import {HospRealizeOrderEdit} from "./HospRealizeOrderEdit";


export default {
    list: HospRealizeOrderList,
    edit: HospRealizeOrderEdit
};
